var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgDiscountCardHeader = function SvgDiscountCardHeader(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1368.67 166.61",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #a5c9ea;\n      }\n\n      .cls-3 {\n        fill: #27245f;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-7 {\n        fill: #1b4686;\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath);\n      }"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 230.73,
    width: 6.23,
    height: 166.15
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,83.33c0,46.02,37.27,83.28,83.28,83.28s83.28-37.27,83.28-83.28S129.24.04,83.28.04,0,37.31,0,83.33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -25.56,
    y1: -46.88,
    x2: -24.31,
    y2: -46.88,
    gradientTransform: "translate(3416.9192 -6184.8591) scale(133.6934 -133.6934)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#010598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#000f9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0059b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0076b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076b9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M306.23,20.84h31.06c38.25,0,58.7,21.8,58.7,60.56s-20.45,61.68-57.95,61.68h-31.81V20.84ZM336.15,130.4c28.97,0,43.55-18.07,43.55-49s-14.58-47.89-43.55-47.89h-14.2v96.89h14.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M418.33,24.01c0-5.96,4.73-9.87,10.79-9.87s10.79,3.91,10.79,9.87-4.73,9.88-10.79,9.88-10.79-4.1-10.79-9.88ZM421.17,52.52h15.53v90.56h-15.53V52.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M457.53,132.83l7.76-10.25c7.95,6.34,16.1,10.81,27.08,10.81,12.12,0,18.18-6.34,18.18-14.16,0-9.32-10.98-13.42-21.02-17.14-13.07-4.66-27.46-10.81-27.46-26.09s11.74-25.71,31.62-25.71c11.55,0,21.59,4.66,28.59,10.25l-7.39,9.69c-6.25-4.66-12.88-8.01-21.02-8.01-11.55,0-16.85,6.15-16.85,13.04,0,8.57,10.04,11.74,20.45,15.65,13.26,4.84,28.03,10.25,28.03,27.39,0,14.72-11.93,27.02-33.71,27.02-13.07,0-25.56-5.4-34.28-12.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M540.28,97.98c0-30.37,20.64-47.7,44.31-47.7,12.12,0,20.45,4.84,26.89,10.62l-7.95,10.06c-5.3-4.66-10.98-8.01-18.37-8.01-16.66,0-28.78,14.16-28.78,35.03s11.55,34.66,28.41,34.66c8.52,0,15.91-4.1,21.59-9.13l6.82,10.25c-8.33,7.27-18.75,11.55-29.73,11.55-24.43,0-43.18-17.33-43.18-47.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M622.65,97.98c0-30.37,20.07-47.7,42.61-47.7s42.61,17.33,42.61,47.7-20.07,47.33-42.61,47.33-42.61-17.33-42.61-47.33ZM691.77,97.98c0-20.87-10.61-35.03-26.51-35.03s-26.51,14.16-26.51,35.03,10.79,34.66,26.51,34.66,26.51-13.97,26.51-34.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M726.07,109.91v-57.39h15.72v55.34c0,16.96,5.11,24.22,17.23,24.22,9.47,0,16.1-4.66,24.81-15.28V52.52h15.53v90.56h-12.88l-1.33-14.16h-.57c-8.52,9.88-17.61,16.4-30.3,16.4-19.5,0-28.22-12.3-28.22-35.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M824.14,52.52h12.88l1.33,13.04h.57c8.71-8.57,18.18-15.28,30.87-15.28,19.32,0,28.03,12.3,28.03,35.4v57.39h-15.53v-55.34c0-16.96-5.3-24.22-17.42-24.22-9.47,0-15.91,4.84-25.19,13.97v65.59h-15.53V52.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M930.37,115.12v-50.12h-13.63v-11.55l14.39-.93,1.89-25.34h13.07v25.34h24.81v12.48h-24.81v50.31c0,11.18,3.6,17.52,14.2,17.52,3.22,0,7.39-1.3,10.42-2.42l3.03,11.55c-5.11,1.68-11.36,3.35-17.04,3.35-19.69,0-26.32-12.3-26.32-30.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1023.92,81.96c0-39.32,23.48-63.35,55.11-63.35,15.15,0,26.89,7.08,34.09,15.09l-8.52,10.06c-6.63-6.89-14.77-11.55-25.38-11.55-23.48,0-39.01,19.01-39.01,49.38s14.96,50.12,38.44,50.12c11.93,0,20.83-5.22,28.78-13.79l8.71,9.69c-9.85,11.18-21.97,17.7-38.06,17.7-31.06,0-54.16-23.48-54.16-63.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1132.04,119.6c0-19.75,17.23-29.63,56.43-33.91,0-11.55-3.79-22.73-18.94-22.73-10.6,0-20.26,4.85-27.46,9.69l-6.06-10.62c8.52-5.4,21.4-11.74,36.17-11.74,22.53,0,32,14.72,32,37.27v55.53h-12.88l-1.33-10.81h-.57c-8.71,7.08-18.94,13.04-30.49,13.04-15.34,0-26.89-9.5-26.89-25.71ZM1188.48,120.9v-25.15c-30.68,3.73-41.28,11.18-41.28,22.73,0,10.25,7.2,14.53,16.29,14.53s16.1-4.29,25-12.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1230.81,52.52h12.88l1.33,16.4h.57c6.25-11.37,15.72-18.63,26.13-18.63,3.98,0,6.82.56,9.85,1.86l-3.03,13.42c-3.03-.93-5.11-1.49-8.9-1.49-7.76,0-17.04,5.59-23.29,20.87v58.14h-15.53V52.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1288,97.98c0-29.44,18.94-47.7,39.96-47.7,10.6,0,17.61,3.91,25.75,10.43l-.76-15.47V10.41h15.72v132.67h-12.88l-1.33-10.62h-.57c-7.2,6.89-17.04,12.86-27.84,12.86-23.1,0-38.06-17.14-38.06-47.33ZM1352.95,119.97v-47.33c-7.76-6.89-14.77-9.5-22.35-9.5-14.77,0-26.51,13.97-26.51,34.66s9.28,34.66,25.38,34.66c8.52,0,15.91-4.1,23.48-12.48Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 230.73,
    y: 0,
    width: 6.23,
    height: 166.15
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 0.04,
    width: 166.57,
    height: 166.57
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M83.28,69.67v57.1c15.76,0,28.52-12.76,28.52-28.52s-12.76-28.52-28.52-28.52v-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.53,98.25v28.52h-14.26c-7.91,0-14.26-6.41-14.26-14.26s6.41-14.26,14.26-14.26h14.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.28,63.2c12.04,0,22.65,6.41,28.52,15.94v-30.2c0-7.91-6.41-14.26-14.26-14.26s-14.26,6.41-14.26,14.26v14.26Z"
  }))));
};
export { SvgDiscountCardHeader as ReactComponent };
export default __webpack_public_path__ + "static/media/discount-card-header.c67ab1f7.svg";